<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="grey-page">
		<section class="container-small">
			<h3 class="page__main-title" v-if="restatus == 'active'">Live Properties</h3>
			<h3 class="page__main-title" v-else-if="restatus == 'archived'">Archived Properties</h3>
			<h3 class="page__main-title" v-else-if="restatus == 'appraisal'">Appraisal Properties</h3>
			<!-- <a href="#" class="properties-list-filter" @click="archived">{{ active ? activeText : archivedText }}</a> -->
			<div class="properties-list__filters mdc-layout-grid">
				<div class="mdc-layout-grid__inner">
					<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-4-tablet">
						<a style="margin-right:0px" href="#" class="properties-list__filter properties-list__filter--left" :class="{'properties-list__filter--active': isSales}" @click="isSales = true"><i class="ico"></i>Sales <small>({{ numSales }})</small></a>
						<a style="margin-right:0px" href="#" class="properties-list__filter properties-list__filter--left" :class="{'properties-list__filter--active': !isSales}" @click="isSales = false"><i class="ico"></i>Lettings <small>({{ numLettings }})</small></a>
					</div>
					<div class="properties-list__archived-filter mdc-layout-grid__cell mdc-layout-grid__cell--span-8 mdc-layout-grid__cell--span-4-tablet">
						<a href="#" class="properties-list__filter" :class="{'properties-list__filter--active': restatus == 'archived'}" @click="setStatus('archived')" style="margin-left: 2px;margin-right:0px"><i class="ico ico-archive"></i>Archived <small>({{ total_archived }})</small></a>
						<a href="#" class="properties-list__filter" :class="{'properties-list__filter--active': restatus == 'active'}" @click="setStatus('active')" style="margin-left: 2px;margin-right:0px"><i class="ico ico-checkmark"></i>Live <small>({{ total_live }})</small></a>
            <a href="#" class="properties-list__filter" :class="{'properties-list__filter--active': restatus == 'appraisal'}" @click="setStatus('appraisal')" style="margin-left: 2px;margin-right:0px"><i class="ico ico-delete"></i>Appraisal <small>({{ total_appraisal }})</small></a>
					</div>
				</div>
			</div>
      <div class="mdc-textfield mdc-textfield--fullwidth mdc-text-field--dense mdc-textfield--with-trailing-icon mdc-ripple-upgraded">
        <input id="search" class="mdc-textfield__input marketplace-header__search-input" type="text" placeholder="Search..." v-model="search"/>
        <i class="mdc-textfield__icon ico ico-search"></i>
      </div>

			<div class="properties-list">
				<div v-if="!propertiesLoaded" class="margin-top-60 text-center">
					<div class="">
						<p class="mdc-theme-primary-dark loading-text">Loading properties<span>.</span><span>.</span><span>.</span></p>
					</div>
				</div>

				<div v-if="propertiesLoaded && properties.length === 0" class="text-center margin-top-60">
					<div class="subtle-text">There are no properties yet!</div>
					<div v-if="restatus == 'active'"><a href="#" class="font-larger" @click.prevent="$router.push('/properties/add')">Add a Property</a></div>
				</div>
				<br>
				<property-box  v-for="(property, index) in properties" v-if="propertiesLoaded && property.serviceType == 'sales' && isSales" :key="property.propertyId" :property="property" :arrayIndex="index" @remove="remove(arguments[0])" v-model="properties"></property-box>
				<property-box  v-for="(property, index) in properties" v-if="propertiesLoaded && property.serviceType == 'lettings' && !isSales" :key="property.propertyId" :property="property" :arrayIndex="index" @remove="remove(arguments[0])" v-model="properties"></property-box>
			</div>
		</section>

		<!-- Add Property Button -->
		<figure class="btn-add-property--fixed">
			<button class="mdc-fab material-icons mdc-ripple-upgraded" type="button" aria-label="addProperty" @click.prevent="$router.push('/properties/add')"><i class="ico-plus_math mdc-fab__icon"></i></button>
		</figure>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import PropertyBox from '../components/PropertyBox.vue';

export default {
	data: function() {
		return {
			properties: [],
      allproperties: [],
			propertiesLoaded: false,
			restatus: 'active',
			isSales: false,
      search: ''
		}
	},
	components: {
		'property-box': PropertyBox
	},
	created: async function() {
		this.properties = await api({endpoint: this.config.services.properties, path: '/', method: 'GET'});
    this.allproperties = this.properties;
    this.propertiesLoaded = true;
    let reproperties = await api({endpoint: this.config.services.properties, path: '/archived', method: 'GET'});
    this.allproperties = this.allproperties.concat(reproperties);
    reproperties = await api({endpoint: this.config.services.properties, path: '/appraisal', method: 'GET'});
    this.allproperties = this.allproperties.concat(reproperties);
    this.liveSearch(this.search);
	},
	computed: {
    total_archived() {
      const total = this.allproperties.filter( p => {
        return p.archived
      });
      return total.length;
    },
    total_live() {
      const total = this.allproperties.filter( p => {
        return (p.status && p.status.toLowerCase() != 'appraisal') && !p.archived
      });
      return total.length;
    },
    total_appraisal() {
      const total = this.allproperties.filter( p => {
        return p.status && p.status.toLowerCase() == 'appraisal'
      });
      return total.length;
    },
		numLettings() {
  		 return this.properties.reduce(function(total, property) {
  			 if(property.serviceType == 'lettings') {
  				 return total + 1;
			 } else {
  				 return total;
  			 }
  		 }, 0);
  	},
		numSales() {
  		 return this.properties.reduce(function(total, property) {
  			 if(property.serviceType == 'sales'){
				 return total + 1;
			 } else {
  				 return total;
  			 }
  		 }, 0);
  	 	},
	},
  watch: {
		search: function() {
			this.liveSearch(this.search);
		},
  },
	methods: {
    inArray: async function(array1,array2) {
      let found = false;
      await Promise.all(array1.map(i => {
        if (found) {
          return true;
        }
        if (array2.indexOf(array1[i]) !== -1) {
          found = true;
        }
      }));
      return found;
    },
    liveSearch: function(txt) {
      this.setStatus();
      if (!txt || txt == '') {
        txt = this.search;
      }
      if (!txt || txt == '') {
        this.properties = this.properties;
        return true;
      }
      txt = txt.toLowerCase();
      this.properties = this.properties.filter(p => {
        return p.address && ((p.address.street && p.address.street.toLowerCase().indexOf(txt) !== -1) || (p.address.buildingNumber && p.address.buildingNumber.toLowerCase().indexOf(txt) !== -1) || (p.address.flatNumber && p.address.flatNumber.toLowerCase().indexOf(txt) !== -1));
      });
    },
		remove: function(index) {
			this.properties.splice(index, 1);
		},
    setStatus: async function(status) {
      const that = this;
			this.propertiesLoaded = false;
      if (status)
        this.restatus = status;

      this.properties = this.allproperties.filter(p => {
        if (that.restatus == 'active') {
          return (p.status != 'appraisal' || p.status != 'Appraisal') && !p.archived;
        } else if (that.restatus == 'archived') {
          return p.archived;
        } else if (that.restatus == 'appraisal') {
          return p.status == 'appraisal' || p.status == 'Appraisal';
        }
        return false;
      });
      this.propertiesLoaded = true;
    }
		// archived: async function() {
		// 	this.isActive = false;
		// 	if(!this.isActive){
		// 	}
		// 	this.propertiesLoaded = true;
		// }
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Properties.vue